import React from "react";
import { Dropdown } from "primereact/dropdown";

const UserProfileSelect = ({
  fieldLabel,
  name,
  value,
  onChange,
  options,
  placeholder = "Select",
  optionLabel = "label",
  optionValue = "value",
  filter = true,
}) => {
  const normalizedOnChange = (e) => {
    onChange?.({ target: { name, value: e.value } });
  };

  const valueTemplate = (opt, props) => (opt ? <span>{opt[optionLabel]}</span> : <span>{props.placeholder}</span>);
  const itemTemplate = (opt) => <span>{opt[optionLabel]}</span>;

  return (
    <div className="form-group col-xl-12">
      <label className="me-sm-2">{fieldLabel}</label>
      <Dropdown
        id={name}
        name={name}
        value={value}
        options={options}
        onChange={normalizedOnChange}
        optionLabel={optionLabel}
        optionValue={optionValue}
        className="w-100"
        placeholder={placeholder}
        valueTemplate={valueTemplate}
        itemTemplate={itemTemplate}
        filter={filter}
      />
    </div>
  );
};

export default UserProfileSelect;
